import { useEffect, useState } from 'react';

/*
 * Превключвател на темата — Светла → Тъмна → Тюркоазена, като в Деливери.
 *
 * Изборът се помни в браузъра (localStorage['theme']), значи по
 * устройство, не по потребител. Класът стои на <html>; без клас е
 * светла. Първото слагане е в index.html, преди React, за да няма
 * премигване при зареждане.
 */
const ORDER = ['light', 'dark', 'turquoise', 'spring', 'summer', 'xmas'];
const ICON = { light: '☀️', dark: '🌙', turquoise: '🌊', spring: '🌸', summer: '🐚', xmas: '🎄' };
const NAME = { light: 'Светла', dark: 'Тъмна', turquoise: 'Тюркоазена', spring: 'Пролет', summer: 'Лято', xmas: 'Коледа' };

/*
 * Коледа сама (19.10.2026): от 1 декември до 15 януари темата е коледна,
 * освен ако човекът я е сменил ръчно през този сезон. Сезонът носи годината
 * на декември — 15.01.2027 е още сезон „2026“. Изборът му се пази в
 * localStorage['themeSeason']; следващия декември коледната тръгва пак, а
 * след 15 януари всеки е на темата, която си е избрал преди (тя не се
 * презаписва с „Коледа“ автоматично). Същата сметка има и в index.html.
 */
export function koledenSezon(d = new Date()) {
  const m = d.getMonth() + 1;
  if (m === 12) return String(d.getFullYear());
  if (m === 1 && d.getDate() <= 15) return String(d.getFullYear() - 1);
  return null;
}

function izbranaTema() {
  try {
    const t = localStorage.getItem('theme');
    if (t === 'dark' || t === 'turquoise' || t === 'spring' || t === 'summer' || t === 'xmas') return t;
  } catch { /* localStorage недостъпен — светла */ }
  return 'light';
}

export function savedTheme() {
  const sezon = koledenSezon();
  if (sezon) {
    let smenena = null;
    try { smenena = localStorage.getItem('themeSeason'); } catch { /* */ }
    if (smenena !== sezon) return 'xmas';
  }
  return izbranaTema();
}

export function applyThemeClass(theme) {
  const root = document.documentElement;
  root.classList.toggle('dark', theme === 'dark');
  root.classList.toggle('turquoise', theme === 'turquoise');
  root.classList.toggle('spring', theme === 'spring');
  root.classList.toggle('summer', theme === 'summer');
  root.classList.toggle('xmas', theme === 'xmas');
}

export default function ThemeToggle() {
  const [theme, setTheme] = useState(savedTheme);

  useEffect(() => { applyThemeClass(theme); }, [theme]);

  // Записва се само ръчният избор — автоматичната „Коледа“ не се помни
  // като избор, за да се върне всеки на своята тема след сезона.
  const next = () => {
    const nova = ORDER[(ORDER.indexOf(theme) + 1) % ORDER.length];
    try {
      localStorage.setItem('theme', nova);
      const sezon = koledenSezon();
      if (sezon) localStorage.setItem('themeSeason', sezon);
    } catch { /* пренебрегваме */ }
    setTheme(nova);
  };

  return (
    <button type="button" className="link" onClick={next}
      title="Смени темата" aria-label={`Тема: ${NAME[theme]} (смени)`}>
      {ICON[theme]} Тема: {NAME[theme]}
    </button>
  );
}
